// src/components/icon-map.tsx
import {
  IconBulb,
  IconLayoutDashboard,
  IconMicrophoneFilled,
} from '@tabler/icons-react'
import { AudioWaveform, Command, GalleryVerticalEnd } from 'lucide-react'

// eslint-disable-next-line react-refresh/only-export-components
export const iconMap = {
  IconBulb,
  IconMicrophoneFilled,
  IconLayoutDashboard,
  AudioWaveform,
  Command,
  GalleryVerticalEnd,
} as const

// Explicitly import all icons to prevent tree-shaking
export const Icons = () => (
  <>
    <IconBulb />
    <IconMicrophoneFilled />
    <IconLayoutDashboard />
    <AudioWaveform />
    <Command />
    <GalleryVerticalEnd />
  </>
)
